import { useMemo } from "react";
import { ExternalLink, FileText } from "lucide-react";
import { openPdfBlobOnMobile } from "@/lib/mail/mobilePdfPreview";

type Props = {
  filename: string;
  blob: Blob;
  blobUrl: string;
  serverUrl: string;
};

export function MobilePdfPreviewPanel({ filename, blob, blobUrl, serverUrl }: Props) {
  const sizeLabel = useMemo(() => {
    const ext = filename.split(".").pop()?.toUpperCase();
    return ext === "PDF" ? "Document PDF" : "Pièce jointe";
  }, [filename]);

  function handleOpen() {
    openPdfBlobOnMobile({ blob, blobUrl, filename });
  }

  return (
    <div className="pointer-events-auto mail-mobile-pdf flex h-full min-h-0 flex-col items-center justify-center gap-5 px-6 py-8 text-center">
      <div className="mail-mobile-pdf__icon" aria-hidden>
        <FileText className="h-10 w-10 text-red-600" strokeWidth={1.5} />
      </div>
      <div className="min-w-0 max-w-full space-y-1">
        <p className="truncate text-sm font-semibold text-[var(--mail-text)]">{filename}</p>
        <p className="text-xs text-[var(--mail-muted)]">{sizeLabel}</p>
      </div>
      <p className="max-w-xs text-xs leading-relaxed text-[var(--mail-muted)]">
        Sur mobile, le PDF s’ouvre dans le lecteur de votre appareil pour une lecture fluide.
      </p>
      <button
        type="button"
        onClick={handleOpen}
        className="mail-mobile-pdf__open inline-flex w-full max-w-xs items-center justify-center gap-2 rounded-xl bg-[var(--mail-accent)] px-4 py-3 text-sm font-semibold text-white shadow-[var(--mail-shadow-sm)] transition active:scale-[0.98]"
      >
        <ExternalLink className="h-4 w-4" aria-hidden />
        Ouvrir le PDF
      </button>
      <a
        href={serverUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs font-medium text-[var(--mail-accent)] underline-offset-2 hover:underline"
      >
        Ouvrir via le serveur
      </a>
    </div>
  );
}
